import {createFileRoute} from '@tanstack/react-router';

import {assetKeys} from '@/features/Asset/api/queryKeys';
import {getAssets} from '@/features/Asset/api/readAssets';
import {checklistTemplateKeys} from '@/features/Library/api/queryKeys';
import {getChecklistTemplates} from '@/features/Library/api/readChecklistTemplates';
import {projectKeys} from '@/features/Project/api/queryKeys';
import {getProject} from '@/features/Project/api/readProject';
import {UpdateProjectForm} from '@/features/Project/components/Form/UpdateProjectForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/inspections/update/$projectId')({
  component: UpdateProjectForm,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(`Edit ${params.projectId}`);

    return {
      ...context,
      readProjectQuery: {
        queryKey: projectKeys.detail(params.projectId),
        queryFn: () => getProject(params.projectId),
      },
      readAssetsQuery: {
        queryKey: assetKeys.lists(),
        queryFn: () => getAssets(),
      },
      readChecklistTemplatesQuery: {
        queryKey: checklistTemplateKeys.lists(),
        queryFn: () => getChecklistTemplates(),
      },
    };
  },

  loader({context}) {
    return Promise.all([
      context.queryClient.ensureQueryData(context.readProjectQuery),
      context.queryClient.ensureQueryData(context.readAssetsQuery),
      context.queryClient.ensureQueryData(context.readChecklistTemplatesQuery),
    ]);
  },
});
